import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Card, Typography, Spin } from "antd";
import { useShow } from "@refinedev/core";
import { SOURCING_ONE_QUERY } from "../queries";
import { Sourcing, SourcingStatus } from "../interface";
import { PublishSourcingForm } from "./PublishSourcingForm";

const { Title, Text } = Typography;

export const PublishSourcing: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { query } = useShow<Sourcing>({
    resource: "sourcings",
    id: id,
    meta: { gqlQuery: SOURCING_ONE_QUERY },
  });

  const { data, isLoading } = query;
  const record = data?.data;

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!record) {
    return (
      <Card>
        <Title level={4}>Sourcing Not Found</Title>
        <Text>The requested sourcing could not be found.</Text>
        <br />
        <br />
        <button onClick={() => navigate('/sourcings')}>
          Back to Sourcings
        </button>
      </Card>
    );
  }

  // Check if sourcing is approved
  if (record.status !== SourcingStatus.APPROVED) {
    return (
      <Card>
        <Title level={4}>Cannot Publish Sourcing</Title>
        <Text>This sourcing must be approved before it can be published to the portal.</Text>
        <br />
        <br />
        <button onClick={() => navigate(`/sourcings/show/${id}`)}>
          Back to Sourcing
        </button>
      </Card>
    );
  }

  const handleBack = () => {
    navigate(`/sourcings/show/${id}`);
  };

  return (
    <PublishSourcingForm
      sourcingId={id!}
      sourcingData={record}
      onBack={handleBack}
    />
  );
};
